/**
 * In production Caddy serves the mini app and Nest owns `/api` on the same origin, so a relative
 * base is correct there. In development Vite runs on 5173 and Nest on 3000, which is why the
 * server allows http://localhost:5173 as a CORS origin.
 */
const DEVELOPMENT_API_BASE_URL = 'http://localhost:3000/api';
const PRODUCTION_API_BASE_URL = '/api';

const defaultBaseUrl = import.meta.env.DEV ? DEVELOPMENT_API_BASE_URL : PRODUCTION_API_BASE_URL;

export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? defaultBaseUrl;
